module.exports = __webpack_public_path__ + "assets/img/18_1861_big.23c746ee.jpg";